import axiosInstance from "@lib/axios";

export async function getSubscriptionCoupon(code) {
  try {
    const res = await axiosInstance.get(`/coupons/subscription_coupons/${code}`);
    const coupon = res.data;
    return coupon;
  } catch (err) {
    return { error_code: "invalid" };
  }
}

export async function getCartCoupon(code, packageItemUids) {
  const res = await axiosInstance.get(`/coupons/cart_coupons/${code || "invalid"}`, {
    params: { package_item_uids: packageItemUids },
  });
  const coupon = res.data;
  return coupon;
}
